module.exports = __webpack_public_path__ + "img/download-grey24.c7fb630c.svg";